export class ReviewUserModel {
    public login: string;
    public gender: 'Male' | 'Female';
    public age: number;
    public ageLabel: string;
    public verified: boolean = false;
}
